
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// const observer = new IntersectionObserver((entries) => {
//     entries.forEach(e => {
//         if (e.isIntersecting) {
//             if (!e.target.classList.contains('animar')) {
//                 console.log("NA INCLUDES", e.target.classList)
//                 e.target.classList.add('animar');
//             } else {
//                 console.log("INCLUDES", e.target.classList)
//             }
//         } else {
//             e.target.classList.remove('animar');
//         }
//     });
// });
// const elementosAnimados = document.querySelectorAll('.animado');
// elementosAnimados.forEach(el => observer.observe(el));
// var sal = require('sal.js');
var $a3d782d1037e1f42$exports = {};
!function(e, t) {
    $a3d782d1037e1f42$exports = t();
}($a3d782d1037e1f42$exports, function() {
    return (()=>{
        "use strict";
        var e = {
            d: (t, n)=>{
                for(var r in n)e.o(n, r) && !e.o(t, r) && Object.defineProperty(t, r, {
                    enumerable: !0,
                    get: n[r]
                });
            },
            o: (e, t)=>Object.prototype.hasOwnProperty.call(e, t)
        }, t = {};
        function n(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var r = Object.getOwnPropertySymbols(e);
                t && (r = r.filter(function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })), n.push.apply(n, r);
            }
            return n;
        }
        function r(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? n(Object(r), !0).forEach(function(t) {
                    o(e, t, r[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                });
            }
            return e;
        }
        function o(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = n, e;
        }
        e.d(t, {
            default: ()=>j
        });
        var a = "Sal was not initialised! Probably it is used in SSR.", s = "Your browser does not support IntersectionObserver!\nGet a polyfill from here:\nhttps://github.com/w3c/IntersectionObserver/tree/master/polyfill", i = {
            root: null,
            rootMargin: "0% 50%",
            threshold: .5,
            animateClassName: "sal-animate",
            disabledClassName: "sal-disabled",
            enterEventName: "sal:in",
            exitEventName: "sal:out",
            selector: "[data-sal]",
            once: !0,
            disabled: !1
        }, l = [], c = null, u = function(e) {
            e && e !== i && (i = r(r({}, i), e));
        }, d = function(e) {
            e.classList.remove(i.animateClassName);
        }, f = function(e, t) {
            var n = new CustomEvent(e, {
                bubbles: !0,
                detail: t
            });
            t.target.dispatchEvent(n);
        }, b = function() {
            document.body.classList.add(i.disabledClassName);
        }, p = function() {
            c.disconnect(), c = null;
        }, m = function() {
            return i.disabled || "function" == typeof i.disabled && i.disabled();
        }, v = function(e, t) {
            e.forEach(function(e) {
                var n = e.target, r = void 0 !== n.dataset.salRepeat, o = void 0 !== n.dataset.salOnce, a = r || !(o || i.once);
                e.intersectionRatio >= i.threshold ? (function(e) {
                    e.target.classList.add(i.animateClassName), f(i.enterEventName, e);
                }(e), a || t.unobserve(n)) : a && function(e) {
                    d(e.target), f(i.exitEventName, e);
                }(e);
            });
        }, y = function() {
            var e = [].filter.call(document.querySelectorAll(i.selector), function(e) {
                return !function(e) {
                    return e.classList.contains(i.animateClassName);
                }(e, i.animateClassName);
            });
            return e.forEach(function(e) {
                return c.observe(e);
            }), e;
        }, O = function() {
            b(), p();
        }, h = function() {
            document.body.classList.remove(i.disabledClassName), c = new IntersectionObserver(v, {
                root: i.root,
                rootMargin: i.rootMargin,
                threshold: i.threshold
            }), l = y();
        }, g = function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            p(), Array.from(document.querySelectorAll(i.selector)).forEach(d), u(e), h();
        }, w = function() {
            var e = y();
            l.push(e);
        };
        const j = function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : i;
            if (u(e), "undefined" == typeof window) return console.warn(a), {
                elements: l,
                disable: O,
                enable: h,
                reset: g,
                update: w
            };
            if (!window.IntersectionObserver) throw b(), Error(s);
            return m() ? b() : h(), {
                elements: l,
                disable: O,
                enable: h,
                reset: g,
                update: w
            };
        };
        return t.default;
    })();
});


(0, (/*@__PURE__*/$parcel$interopDefault($a3d782d1037e1f42$exports)))({
    threshold: 0.5,
    once: false
});
if (document.readyState !== "loading") {
    console.log("document is already ready, just execute code here");
    setTimeout($74c1047cf03e21b4$var$iniciar, 2500);
} else document.addEventListener("DOMContentLoaded", (event)=>{
    console.log("loaded");
    setTimeout($74c1047cf03e21b4$var$iniciar, 2500);
});
document.addEventListener("scroll", $74c1047cf03e21b4$var$initOnEvent);
document.addEventListener("mousemove", $74c1047cf03e21b4$var$initOnEvent);
document.addEventListener("touchstart", $74c1047cf03e21b4$var$initOnEvent);
function $74c1047cf03e21b4$var$initOnEvent(event) {
    $74c1047cf03e21b4$var$iniciar();
    event.currentTarget.removeEventListener(event.type, $74c1047cf03e21b4$var$initOnEvent); // remove the event listener that got triggered
}
async function $74c1047cf03e21b4$var$initPixel(f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function() {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
    fbq("init", "7564065500290435");
    fbq("track", "PageView");
}
async function $74c1047cf03e21b4$var$iniciar() {
    if (window.DidInit) return false;
    console.log("Iniciar libs");
    window.DidInit = true;
    try {
        $74c1047cf03e21b4$var$initPixel(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    } catch  {
        console.log("Erro ao iniciar o pixel");
    }
// initGtm(window, document, 'script', 'dataLayer', 'GTM-MPN6L4P3');
}
window.metodoSim = function() {
    window.open("https://metodosimformacao.com.br/", "_blank");
};
window.enviarFormComp = function(e, id, lid, slug) {
    try {
        e.preventDefault();
        const form = document.getElementById(id);
        if (!form.checkValidity()) return form.reportValidity();
        else submitForm(e, form, slug, lid);
    } catch (error) {
        console.log("ERRO AO ENVIAR", error);
    }
};
window.submitForm = function(event, form, redirect, id) {
    // if (redirect) { irPara(`pagamento?curso=${redirect}&tipo=${window.selecionado}`); return }
    var url = "https://paginas.rocks/pages/index/" + id;
    var request = new XMLHttpRequest();
    request.open("POST", url, true);
    request.onload = function() {
        if (redirect) irPara(`pagamento?curso=${redirect}&tipo=${window.selecionado}`);
    };
    request.onerror = function() {
        // request failed
        console.log("ERRO AO ENVIAR");
    };
    request.send(new FormData(form)); // create FormData from form that triggered event
    event.preventDefault();
};
window.modalPlanos = function(tipo) {
    if (!window.modal) window.modal = document.getElementById("modal-one");
    window.selecionado = tipo;
    modal.classList.toggle("open");
};


//# sourceMappingURL=repo.e731fd62.js.map
